import { render, staticRenderFns } from "./BestaetigenReservierungNeu.vue?vue&type=template&id=5106008a"
import script from "./BestaetigenReservierungNeu.vue?vue&type=script&lang=ts"
export * from "./BestaetigenReservierungNeu.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports